import React, { useEffect, useState } from "react";
import Header from "./Component/Header";
import NavBar from "./Component/NavBar";
import Footer from "./Component/Footer";
import GDesign from "./Component/GDesign";
import  { db } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";




const Gallery = () => {
   

    const [imageUrls, setImageUrls] = useState([]);

    useEffect(() => {
      const fetchImages = async () => {
        try {
          const querySnapshot = await getDocs(collection(db, "gallery"));
          const images = [];
          querySnapshot.forEach((doc) => {
            const { name, description, url } = doc.data();
            images.push({ id: doc.id, name, description, url });
          });
          setImageUrls(images)
          console.log(images)
        } catch (error) {
          console.error("Error fetching images: ", error);
        }
      };
      fetchImages();

    }, []);


    return (
        <>
            <Header />
            <NavBar />
            <div className="container py-3 h-100 text-center">
                
                <div className="row">
                    <div className="col text-center">
                        <div className="TabTitle text-center mt-4">
                            <b className="my_title fs-3">Gallery</b>
                        </div>
                    </div>
                </div>
                <br></br>
                <section className="booklist text-center">
                    {imageUrls.map((gdesigns) => {
                        return <GDesign key={gdesigns.id} {...gdesigns}></GDesign>;
                    })}
                </section>
            </div>
             <Link to='/exam'><button>Start</button></Link>
            <Footer />
        </>
    );
};
export default Gallery;